import { CalendarZoomFactors } from '../../../features/calendar/calendar-types';

export class CalendarConfigModel {
  public hoursOfDay = -1;
  public defaultCalendarView = -1;
  public timeFormat = '';
  public timeBlockDraggingDuration = -1;
  public minimumTimeBlockDuration = -1;
  public zoomFactor: CalendarZoomFactors = CalendarZoomFactors.ZoomZero;
}
